import { type RefObject, useEffect, useRef } from 'react';

import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface PoiInteractionState {
    prevFilterTypeRef: RefObject<POIFilterType | undefined>;
    prevIndexRef: RefObject<number | undefined>;
    selectedPoiIndexRef: RefObject<number | undefined>;
}

export const usePoiSelectionInfo = (): PoiInteractionState => {
    const prevFilterTypeRef = useRef<POIFilterType | undefined>(
        usePlacementStore.getState().poiSelection.current.filterType
    );
    const prevIndexRef = useRef<number | undefined>(usePlacementStore.getState().poiSelection.current.index);
    const selectedPoiIndexRef = useRef<number | undefined>(usePlacementStore.getState().poiSelection.current.index);

    useEffect(() => {
        const unsubscribe = usePlacementStore.subscribe(
            (state) => state.poiSelection.current,
            (selection) => {
                selectedPoiIndexRef.current = selection.index;
                prevIndexRef.current = selection.index;
                prevFilterTypeRef.current = selection.filterType;
            }
        );

        return () => unsubscribe();
    }, []);

    return {
        prevFilterTypeRef,
        prevIndexRef,
        selectedPoiIndexRef
    };
};
